"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles information about a supported mock.
 */
var SupportedMock = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {string} name Name of the mock property.
   * @param {string} type Type of the property. Available are: string, number, object, boolean.
   * @param {object} defaultValue Default value that will be used for the initial state of the mock data.
   * @param {object[]|null} [validValues] Array of valid values.
   * @param {boolean} [isRequired] TRUE if required. Default is TRUE.
   */
  function SupportedMock(name, type, defaultValue) {
    var validValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var isRequired = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    _classCallCheck(this, SupportedMock);

    this.name = name;
    this.type = type;
    this.defaultValue = defaultValue;
    this.validValues = validValues || [];
    this.isRequired = isRequired;
  }
  /**
   * Validates a value.
   *
   * @param {object} value Value to validate.
   * @returns {boolean} TRUE if valid.
   */


  _createClass(SupportedMock, [{
    key: "validate",
    value: function validate(value) {
      if ((value === undefined || value === null) && this.isRequired || value !== null && _typeof(value) !== this.type || this.validValues.length > 0 && !this.validValues.includes(value.toString())) {
        return false;
      }

      return true;
    }
  }]);

  return SupportedMock;
}();

exports.default = SupportedMock;